<div class="flex h-screen overflow-hidden" [ngClass]="layoutService.containerClasses()">
  <!-- Sidebar - Toujours présente en desktop, mais avec classes CSS pour le collapse -->

  @if (layoutService.isDesktop()) {
    <app-sidebar></app-sidebar>
  }

  <!-- Content Area -->
  <div class="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
    <!-- Header -->
    <div class="sticky top-0 z-50">
      <app-header></app-header>
    </div>

    <!-- Main Content -->
    <main>
      <div id="mainArea" class="mx-auto p-4 md:p-6" style="min-height: calc(100dvh - 98px);">
        <breadcrumb />
        <titleLayout></titleLayout>

        @if(environment?.debug && environment?.production === false && environment.debug){
          <breakpoint-debug></breakpoint-debug>
          <layout-debug></layout-debug>
          <app-memory-debug></app-memory-debug>
        }

        <!-- Sidebar J+ -->
        <sidebarJplus></sidebarJplus>
        <sinistreSlider></sinistreSlider>

        <router-outlet></router-outlet>
      </div>
    </main>

    <app-footer class="bottom-0 w-full"></app-footer>

  </div>
</div>

